module.exports = "mat-cell {\n  overflow: visible; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/users/components/carriers/carriers.component.scss
// module id = ./src/app/modules/users/components/carriers/carriers.component.scss
// module chunks = main